import React, { Component } from 'react';
import update from 'immutability-helper';
import cx from 'classnames';

import { isTouchDevice } from '../../utilities/feature-tests';
import withOutsideClickListener from '../../decorators/outside-click-listener';
import { withWindow } from '../../decorators/window';

import TranslatedCopy from '../../intl/translated-copy';

class Tooltip extends Component {
  static defaultProps = {
    position: {},
    width: 200,
  }

  constructor() {
    super();

    this.state = {
      position: 'bottom',
      tooltipStyles: {},
    };


    // Default the tooltip position to these values.
    // If the user passes in the position, these will be updated.
    this.positionByBreakpoint = {
      'small': 'bottom',
      'medium': 'bottom',
      'medium-high': 'bottom',
      'large': 'bottom',
    };

    this.handleHideTooltip = this.handleHideTooltip.bind(this);
    this.handleShowTooltip = this.handleShowTooltip.bind(this);
    this.handleToggleTooltip = this.handleToggleTooltip.bind(this);
  }

  componentWillMount() {
    const { breakpoint, position } = this.props;

    this.positionByBreakpoint = update(this.positionByBreakpoint, { $merge: position });

    this.setState({
      position: this.positionByBreakpoint[breakpoint],
      tooltipStyles: this.getTooltipStyles(),
    });
  }

  componentWillReceiveProps(nextProps) {
    const { breakpoint, isActive } = this.props;
    const newState = {};

    if (breakpoint !== nextProps.breakpoint) {
      newState.position = this.positionByBreakpoint[nextProps.breakpoint];
    }

    if (isActive !== nextProps.isActive || this.props.dimensions.x !== nextProps.dimensions.x) {
      newState.position = this.getPosition();
    }

    this.setState(newState);
  }

  componentDidUpdate(prevProps, prevState) {
    const { position } = this.state;
    if (position !== prevState.position) {
      const tooltipStyles = this.getTooltipStyles();

      this.setState({
        tooltipStyles: tooltipStyles,
      });
    }
  }

  render() {
    const {
      className,
      copyID,
      isActive,
      labelID,
      tooltipID,
      light,
    } = this.props;

    const { position, tooltipStyles } = this.state;

    const tooltipWrapperClasses = cx({
      'TooltipWrapper-my-trips': true,
      'is-active': isActive,
    }, className);

    const tooltipLightClasses = cx({
      'TooltipLight-my-trips': true,
      'TooltipLight-my-trips--left': position === 'left',
      'TooltipLight-my-trips--right': position === 'right',
      'TooltipLight-my-trips--top': position === 'top',
      'TooltipLight-my-trips--bottom': position === 'bottom',
    });

    const tooltipClasses = cx({
      'Tooltip-my-trips': true,
      'Tooltip-my-trips--left': position === 'left',
      'Tooltip-my-trips--right': position === 'right',
      'Tooltip-my-trips--top': position === 'top',
      'Tooltip-my-trips--bottom': position === 'bottom',
    });

    return light === false ? (
      <button
        aria-labelledby={ labelID }
        aria-describedby={ tooltipID }
        className={ tooltipWrapperClasses }
        onMouseEnter={ isTouchDevice() ? null : this.handleShowTooltip }
        onMouseLeave={ isTouchDevice() ? null : this.handleHideTooltip }
        onClick={ isTouchDevice() ? this.handleToggleTooltip : null }
        onFocus={ isTouchDevice() ? null : this.handleShowTooltip }
        onBlur={ isTouchDevice() ? null : this.handleHideTooltip }
        type='button' >
        <span className='Tooltip-icon-my-trips'></span>
        <span
          id={ tooltipID }
          role='tooltip-my-trips'
          ref={ (ref) => this.tooltipNode = ref }
          className={ tooltipClasses }
          style={ tooltipStyles }>
          <TranslatedCopy copyID={ copyID } />
        </span>
      </button>
    ) : (
      <button
        aria-labelledby={ labelID }
        aria-describedby={ tooltipID }
        className={ tooltipWrapperClasses }
        onMouseEnter={ isTouchDevice() ? null : this.handleShowTooltip }
        onMouseLeave={ isTouchDevice() ? null : this.handleHideTooltip }
        onClick={ isTouchDevice() ? this.handleToggleTooltip : null }
        onFocus={ isTouchDevice() ? null : this.handleShowTooltip }
        onBlur={ isTouchDevice() ? null : this.handleHideTooltip }
        type='button' >
        <span className='Tooltip-icon-my-trips'></span>
        {
          isActive === true ? <span
            id={ tooltipID }
            role='tooltip-my-trips'
            ref={ (ref) => this.tooltipNode = ref }
            className={ tooltipLightClasses }
            style={ tooltipStyles }>
            <TranslatedCopy copyID={ copyID } />
          </span> : null
        }
      </button>
    );
  }

  /**
    * Guarantee that tooltip doesn't get cut off on touch devices
    */
  getTooltipStyles() {
    const { dimensions, width } = this.props;

    // We want to avoid the tooltip going to very edge of the page: use this margin to prevent that.
    const pageMargin = 20;

    const newTooltipStyles = {
      width: width,
    };
    if (this.tooltipNode) {
      const rect = this.tooltipNode.getBoundingClientRect();

      // If the tooltip extends past the left or right edge of the screen,
      // adjust the width to something that fits.
      if ((rect.left + width) >= dimensions.x - pageMargin) {
        const adjustedWidth = dimensions.x - rect.left - pageMargin;
        newTooltipStyles.width = adjustedWidth;
      } else if ((rect.right - width) <= pageMargin) {
        const adjustedWidth = rect.right - pageMargin;
        newTooltipStyles.width = adjustedWidth;
      }
    }
    if (dimensions.x === 320) {
      newTooltipStyles.width = 150;
    }
    return newTooltipStyles;
  }

  getPosition() {
    const {
      breakpoint,
      dimensions,
      width,
    } = this.props;
    const { position } = this.state;

    let newPosition = position;

    // Try to use the default/user-defined position. If it goes off the edge
    // of the page, change to either 'right' or 'left' so that it fits.
    if (this.tooltipNode) {
      const rect = this.tooltipNode.getBoundingClientRect();
      if (dimensions.x === 320) {
        newPosition = 'right';
      } else if ((rect.left + width) > dimensions.x) {
        newPosition = 'left';
      } else if ((rect.right - width) < 1) {
        newPosition = 'right';
      } else {
        newPosition = this.positionByBreakpoint[breakpoint];
      }
    }

    return newPosition;
  }

  handleShowTooltip(e) {
    const { setActiveTrue } = this.props;

    e.preventDefault();

    setActiveTrue();
  }

  handleHideTooltip(e) {
    const { setActiveFalse } = this.props;

    e.preventDefault();

    setActiveFalse();
  }

  handleToggleTooltip(e) {
    const { toggleActive } = this.props;

    e.preventDefault();

    toggleActive();
  }
}

export default withWindow(withOutsideClickListener(Tooltip));
